import { useEffect, useRef, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import {
  GetNoticeDetailsAnsweresForCompareByNoticeId,
  GetNoticeDetailsAnsweresTableByGroupId,
} from "../../services/GroupService";
import { Button, Input, InputRef, Space, Table } from "antd";
import {
  ColumnsType,
  ColumnType,
  FilterConfirmProps,
  TableRowSelection,
} from "antd/es/table/interface";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import ConvertToShamsi from "../../extentions/convertors/ConvertToShamsi";
import { GetNoticeById } from "../../services/NoticeService";
import axios from "axios";
import { GURL } from "../../services/global";

const NoticePrice = () => {
  interface DataTypeCompany {
    key: React.Key;
    companyId: string;
    name: string;
    count: string;
    sumPrice: string;
  }
  const openNewWindow = (url: any) => {
    // Open a new window
    const newWindow = window.open(url, "_blank", "width=900,height=800");

    // You can manipulate the new window, for example, set its title
    // newWindow.document.title = "New Window";
  };
  const [searchParams] = useSearchParams();
  const params = useParams();

  const [GetCompareData, SetCompareData] = useState<DataTypeCompany[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
  const rowSelection: TableRowSelection<any> = {
    selectedRowKeys,
    onChange: (key: any, rows) => {
      console.log(rows);
      setSelectedRowKeys(key);
    },
  };
  interface DataType {
    key: string;
    name: string;
    age: number;
    address: string;
  }

  type DataIndex = keyof DataType;
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef<InputRef>(null);

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };
  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): ColumnType<DataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`جستجو  `}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            بازنشانی
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            فیلتر
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            بستن
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ?.toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text?.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const compareValues = (a: any, b: any) => {
    // Handle different data types and null/undefined values
    if (typeof a === "string" && typeof b === "string") {
      return a.localeCompare(b);
    } else {
      return a - b;
    }
  };
  interface CustomCellRendererProps {
    record: any; // Replace 'RecordType' with the actual type of your data
    dataIndex: string;
  }
  const PriceAntdCellRendrer: React.FC<CustomCellRendererProps> = ({
    record,
    dataIndex,
  }) => {
    return (
      <span>
        {record.sumPrice
          ?.toString()
          ?.replace(/[^0-9]/g, "")
          ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
      </span>
    );
  };
  const PositionCellRenderer: React.FC<CustomCellRendererProps> = ({
    record,
    dataIndex,
  }) => {
    return (
      <span>
        {GetCompareData.find((p) => p.companyId == record.companyId)?.name}
      </span>
    );
  };
  const columnsDetails: ColumnsType<any> = [
    {
      title: "عنوان",
      dataIndex: "price",
      key: "price",
      width: "20%",
      render: (text: string, record: any) => (
        <>
          {getNoticeData !== null ? (
            <>
              {
                getNoticeData.noticeDetails[
                  getNoticeData.noticeDetails.findIndex(
                    (p: any) => p.id === record.noticeDetailId
                  )
                ]?.title
              }
            </>
          ) : (
            <></>
          )}
        </>
      ),
    },
    {
      title: "پیشنهاد دهنده",
      dataIndex: "sumPrice",
      key: "sumPrice",
      width: "20%",
      render: (text: string, record: any) => (
        <PositionCellRenderer record={record} dataIndex="positionId" />
      ),
    },

    {
      title: "مبلغ  ",
      dataIndex: "price",
      key: "price",
      width: "20%",
    },
    {
      title: "توضیحات",
      dataIndex: "description",
      key: "description",
      width: "20%",
    },
    {
      title: "تاریخ",
      dataIndex: "createDate",
      key: "createDate",
      width: "20%",
      render: (text: string, record: any) => (
        <>{ConvertToShamsi(record.createDate)}</>
      ),
    },
  ];

  const columnsTotal: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",
      width: "5%",
      hidden: false,

      render: (item, record, index) => <>{index + 1}</>,
    },
    {
      title: "فروشگاه",
      dataIndex: "name",
      key: "name",
      width: "30%",

      //   render:(text: string, record: any) => (
      // 	<CustomCellRenderer record={record} dataIndex="companyId" />
      //   ),
      ...getColumnSearchProps("name"),
    },
    {
      title: "مبلغ کل",
      dataIndex: "sumPrice",
      key: "sumPrice",
      width: "20%",
      render: (text: string, record: any) => (
        <PriceAntdCellRendrer record={record} dataIndex="companyId" />
      ),
      sorter: (a, b) => compareValues(a.sumPrice, b.sumPrice),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "تعداد اقلام  ",
      dataIndex: "count",
      key: "count",
      width: "20%",
      sorter: (a, b) => compareValues(a.count, b.count),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "گزارش اقلام",
      dataIndex: "actions",
      key: "actions",
      render: (text, record) => (
        <Button
          type="primary"
          onClick={() =>
            openNewWindow(
              `${window.location.origin}/iframe/reportNoticeDetails?companyId=${record.key}&noticeId=${params.id}`
            )
          }
        >
          پرینت اقلام
        </Button>
      ),
    },
  ];
  const gridRef = useRef(null);

  const [getNoticeData, setNoticeData] = useState<any>(null);
  const [getDetails, setDetails] = useState<[]>([]);

  useEffect(() => {
    if (params.id) {
      SetCompareData([]);
      GetNoticeById(params.id).then((p) => setNoticeData(p.data));
      GetNoticeDetailsAnsweresForCompareByNoticeId(params.id).then((p) => {
        SetCompareData([]);
        console.log(p?.data?.data);

        p.data.data.map((p: any) => {
          SetCompareData((prevItems: any) => [
            ...prevItems,
            {
              key: p.companyId,
              companyId: p.companyId,
              name: p.name,
              count: p.count,
              sumPrice: p.sumPrice,
              forceSupply: p.forceSupply,
            },
          ]);
        });
      });

      GetNoticeDetailsAnsweresTableByGroupId(params.id).then((p) => {
        console.log(p?.data?.data);

        setDetails(p?.data?.data);
      });
    }
  }, [params.id]);
  return (
    <>
      {params.id !== undefined ? (
        <div className="mt-4 px-4" style={{ width: "100%" }}>
          <Button
            className="my-2"
            type="primary"
            onClick={() => {
              const qry = selectedRowKeys
                .map((key) => `${encodeURIComponent(key)}`)
                .join(",");
              openNewWindow(
                `${window.location.origin}/iframe/report?selectedRowKeys=${qry}&noticeId=${params.id}`
              );
              /*SetReportsModal(true)*/
            }}
          >
            گزارش
          </Button>
          <div ref={gridRef}>
            {" "}
            <Table
              rowSelection={rowSelection}
              size="small"
              dataSource={GetCompareData}
              pagination={false}
              columns={columnsTotal}
            />
            <Table
              className="mt-5"
              size="small"
              dataSource={
                selectedRowKeys.length > 0
                  ? getDetails.filter((item: any) =>
                      selectedRowKeys.includes(item.companyId)
                    )
                  : getDetails
              }
              pagination={false}
              columns={columnsDetails}
            />
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default NoticePrice;
